import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const eventDetailGridColumns = (rows) => columnDefs(rows);

function columnDefs(rows) {

    let tempColumnDefs = [];

    rows.map((object) => {
        Object
            .keys(object)
            .map((key) => {
                const mappedColumn = {
                    headerName: key,
                    field: key,
                };
                tempColumnDefs.push(mappedColumn);
            });
    });

    tempColumnDefs = tempColumnDefs.filter((column, index, self) =>
        index === self.findIndex((colAtIndex) => (
            colAtIndex.field === column.field)));

    const columnDefs = [];
    const durationVF = ({ value }) => apiProvider.formatDuration({ seconds: value });
    for (const each of tempColumnDefs) {
        if (each.headerName !== 'id') {
            let hide = false;
            let valueFormatter = null;
            let cellRenderer = null;
            let width = null;
            if (each.headerName === 'Compliant' || each.headerName === 'Automated' ) {
                width = 95;
                hide = true;
            }
            if (each.headerName === 'Duration') {
                valueFormatter = durationVF;
            }
            if (each.headerName === 'k') {
                hide = true;
            }
            columnDefs.push({
                headerName: each.headerName,
                field: each.field,
                hide,
                width,
                valueFormatter,
                cellRenderer,
            });
        }
        
    }
    return columnDefs;
}
